import apiService from 'config/service';
import { TUserStateData } from 'context/reducers/user.type';

export const getUserData = () => apiService.get<TUserStateData>(`/user/me`);

export default getUserData;
